import { apiSlice } from '../../../store/api/apiSlice';

export const transcriptCoverageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTranscriptCoverageCsv: builder.query<string, void>({
      query: () => ({
        url: 'admin/coaches/transcript-coverage/export.csv',
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const { useLazyGetTranscriptCoverageCsvQuery } = transcriptCoverageApi;
